import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ISymbol, SimpleReelModelEventData, SimpleReelModelState} from "../../core/reel/simplereel/IReelData";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DumpsterFireReelView} from "./DumpsterFireReelView";
import {DumpsterFireReelSet} from "../server/DumpsterFireReelSet";
import {TimelineLite} from "gsap";
import {DumpsterFire} from "../DumpsterFire";
import {DumpsterFireSymbol} from "./DumpsterFireSymbol";

export class DFAvalancheReelModel {
    /**
     * Triggers on: ReelStateChange and each ReelModelState
     */
    public readonly events: APIEventSystem | undefined;
    public readonly id: number;
    private _reelSetIndex: number = 0;
    private _spinning: boolean = false;
    private _masterSpinTimeline: TimelineLite | undefined;

    constructor(id: number, triggerEvents: boolean = true) {
        this._reelId = id;
        this._reelView = new DumpsterFireReelView(id);
        if (triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data: SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    private _state: SimpleReelModelState = SimpleReelModelState.IDLE;
    set state(value: SimpleReelModelState) {
        this._state = value;
        if (this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{reel: this.reelId, state: this._state});
        }
    }

    private _reelId: number;
    get reelId(): number {
        return this._reelId;
    }

    private _reelView: DumpsterFireReelView;
    get reelView(): DumpsterFireReelView {
        return this._reelView;
    }

    private _reelSet: string[] | undefined;
    get reelSet(): string[] {
        if (!this._reelSet) {
            throw new Error(`No reelset set for reel: ${this.reelId}`);
        }
        return this._reelSet;
    }

    // public getFillUpReelAnimation(): gsap.core.Timeline {
    //     return this.reelView.getFillUpReelAnimation();
    // }

    public clear() {
        this._reelView.clear();
    }


    public init(symbols: string[]): void {
        this.setReelSet(DumpsterFireReelSet.DEFAULT_REEL_SET[this._reelId]);
        this._reelView.initReel(symbols);
    }

    public setReelSet(reelSet: string[], index?: number): void {
        this._reelSet = reelSet;
        index = index != undefined ? index : Math.floor(Math.random() * this._reelSet.length);
        this.setReelIndex(index);
    }

    /**
     * Adding bounce on reel spin start
     */
    public start(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.state = SimpleReelModelState.START
        });
        tl.add(() => this.startSpin());
        return tl;
    }

    public stop(reelData: string[], reel: number, nearWinReel: boolean, currentWinReel: boolean, fastSpin: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.state = SimpleReelModelState.STOPPED;
                this.state = SimpleReelModelState.IDLE;
            }
        });
        tl.add(this._reelView.stop(reelData, reel, nearWinReel, currentWinReel, fastSpin));
        return tl;
    }

    public getSymbol(position: number): ISymbol {
        return this._reelView.getSymbol(position);
    }

    private setReelIndex(value: number): void {
        if (value >= this.reelSet.length) {
            value = 0;
        } else if (value < 0) {
            value = this.reelSet.length - 1;
        }
        this._reelSetIndex = value;
    }

    /**
     * Starting the actual spin by adding it to the masterSpinTimeline
     * @private
     */
    private startSpin() {
        this._spinning = true;
        this.state = SimpleReelModelState.SPIN;
        this._masterSpinTimeline = new TimelineLite();
        this._masterSpinTimeline.add(this.spin());
    }

    private spin(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(() => {
            this._reelView.getAllOutAnimation()
        });
        timeline.add(() => this.onSpinStartedCompleted());
        return timeline;
    }

    private onSpinStartedCompleted(): void {
        // todo in case anything needs to be done on spin start completed
    }

    private onReelStateChange(data: SimpleReelModelEventData): void {
        this.events?.trigger(data.state, data);
    }
}